/**
 * Axios client for the affiliate portal.
 *
 * Deliberately separate from api.js — affiliates authenticate via an
 * httpOnly session cookie (not a Bearer token), so this instance sends
 * credentials instead of an Authorization header, and never redirects to
 * /login or /billing on error (those are company-account concepts).
 */

import axios from 'axios';
import { getErrorMessage } from './api';

const API_BASE = process.env.REACT_APP_API_URL || '';
const AFFILIATE_BASE = `${API_BASE}/api/affiliate`;

const affiliateApi = axios.create({
  baseURL: AFFILIATE_BASE,
  timeout: 15000,
  withCredentials: true,
});

export { getErrorMessage, AFFILIATE_BASE };
export default affiliateApi;
